module.exports = __webpack_public_path__ + "img/Close.f1991151.svg";